export const formatNumberWithSpaces = (number: number | string, replace = ' ') => {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, replace);
}

export const formatSpecialNumber = (
    special: string | number | null | undefined,
    fixed = 2
) => {
    if (special == null) {
        return '0';
    }

    const numberWithoutSpaces = String(special)
        .replace(/\s+/g, '')
        .replace(',', '.');

    const number = parseFloat(numberWithoutSpaces);

    return number.toFixed(fixed);
};

export const getFutureDateISO = () => {
    const now = new Date();
    const sixtyDaysInMilliseconds = 60 * 24 * 60 * 60 * 1000;
    const futureDate = new Date(now.getTime() + sixtyDaysInMilliseconds);
    return futureDate.toISOString();
}

export const transliterate = (text: string): string => {
    const cyrillicToLatinMap: { [key: string]: string } = {
        'а': 'a',
        'б': 'b',
        'в': 'v',
        'г': 'g',
        'д': 'd',
        'е': 'e',
        'ё': 'yo',
        'ж': 'zh',
        'з': 'z',
        'и': 'i',
        'й': 'y',
        'к': 'k',
        'л': 'l',
        'м': 'm',
        'н': 'n',
        'о': 'o',
        'п': 'p',
        'р': 'r',
        'с': 's',
        'т': 't',
        'у': 'u',
        'ф': 'f',
        'х': 'h',
        'ц': 'ts',
        'ч': 'ch',
        'ш': 'sh',
        'щ': 'shch',
        'ъ': '',
        'ы': 'y',
        'ь': '',
        'э': 'e',
        'ю': 'yu',
        'я': 'ya',
        'А': 'A',
        'Б': 'B',
        'В': 'V',
        'Г': 'G',
        'Д': 'D',
        'Е': 'E',
        'Ё': 'Yo',
        'Ж': 'Zh',
        'З': 'Z',
        'И': 'I',
        'Й': 'Y',
        'К': 'K',
        'Л': 'L',
        'М': 'M',
        'Н': 'N',
        'О': 'O',
        'П': 'P',
        'Р': 'R',
        'С': 'S',
        'Т': 'T',
        'У': 'U',
        'Ф': 'F',
        'Х': 'H',
        'Ц': 'Ts',
        'Ч': 'Ch',
        'Ш': 'Sh',
        'Щ': 'Shch',
        'Ъ': '',
        'Ы': 'Y',
        'Ь': '',
        'Э': 'E',
        'Ю': 'Yu',
        'Я': 'Ya',
    };

    return text
        .split('')
        .map(char => (cyrillicToLatinMap[char] !== undefined ? cyrillicToLatinMap[char] : char))
        .join('');
};